import { call, put, takeLatest, select } from "redux-saga/effects";
import { postSOWDetails } from "../http/requests/sow";
import { SOWType, getSOWData, setVtrackLoader } from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";
import { toast } from "react-toastify";

function* workerSaveSOWSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    yield call(postSOWDetails, payload.data);
    const page = payload.data.pageNo ? payload.data.pageNo + 1 : 1;
    const rows = payload.data.rows || 10;
    const clientId = yield select((state) => state.MODULES.sowListClientFilterId);
    toast.success("SOW Saved", toastOptions);
    yield put(
      getSOWData({
        pageNo: page,
        pageSize: rows,
        sortDir: "ASC",
        sortBy: "sowName",
        searchData: "",
        clientId,
      })
    );
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err?.response?.data?.errorMessage || err?.message || "Failed to save SOW", toastOptions);
    yield put(setVtrackLoader(false));
  }
}

export function* saveSOWSaga() {
  yield takeLatest(SOWType.SAVE_SOW_DATA, workerSaveSOWSaga);
}
